<template lang="pug">
  v-container.contenedor-de-mensajes.pb-0.mt-10
    v-row(justify='center' align='center' ).formulario
      v-col.rojo(xs=12 sm=8 md=8 xl=8).pt-5
        Formulario_de_contacto
    
</template>
<style lang='sass'>
.contenedor-de-mensajes
  height: 550px
  .formulario
    height: 500px
    position: relative!important
    z-index: 20
    @media (max-width: 960px)
      height: 600px
    @media (max-width: 600px)
      height: unset
  @media (max-width: 960px)
    height: 680px
  @media (max-width: 600px)
    height: unset
</style>
<script>
import { mapState } from 'vuex'
export default {
  data: ()=>({
  }),
  computed: {
    Inicio() {
      return this.$contenido.Inicio || {}
    },
    ...mapState({
      Reglas: ({Ayudas})=>Ayudas.reglas,
      
    }),
  },
  components: {
    Formulario_de_contacto: ()=>import('./componentes/Formulario_de_contacto')
  }
}
</script>